// filepath: /Users/a001/code/pk-h5-web/src/views/login/index.jsx
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Toast } from 'antd-mobile';
import { createNonceStr, md5, getLocationSearch } from '@/utils/utils';
import request from '@/utils/request';
import config from '@/config';
import './index.scss';

const Login = () => {
  const [mobilePhone, setMobilePhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isRegisterMode, setIsRegisterMode] = useState(false);
  const history = useHistory();

  useEffect(() => {
    document.title = isRegisterMode ? '注册' : '登录';
    // 设置页面标题（如果在 WebView 中）
    if (typeof window?.savePicture?.setTitle === 'function') {
      window?.savePicture?.setTitle(isRegisterMode ? '注册' : '登录');
    }
  }, [isRegisterMode]);

  // 获取签名参数
  const getSignParams = () => {
    const appKey = 'app_h5';
    const secret = '11dc72cf-88b0-46cd-91d7-b1a77fd69ee1';
    const timestamp = new Date().getTime();
    const random = createNonceStr();
    const tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}`;
    console.log('tempStr:', tempStr);
    const sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
    console.log('sign:', sign);
    return {
      appKey,
      timestamp,
      random,
      sign,
    };
  };

  // 验证手机号格式
  const validatePhone = (phone) => {
    const phoneRegex = /^1[3-9]\d{9}$/;
    return phoneRegex.test(phone);
  };

  // 验证密码格式
  const validatePassword = (pwd) => {
    return pwd.length >= 6;
  };

  // 处理登录
  const handleLogin = async () => {
    // 验证手机号
    if (!mobilePhone) {
      Toast.fail('请输入手机号', 2);
      return;
    }
    
    // if (!validatePhone(mobilePhone)) {
    //   Toast.fail('请输入正确的手机号', 2);
    //   return;
    // }

    // 验证密码
    if (!password) {
      Toast.fail('请输入密码', 2);
      return;
    }

    if (!validatePassword(password)) {
      Toast.fail('密码至少6位', 2);
      return;
    }

    setLoading(true);
    Toast.loading('登录中...', 0, () => {}, true);

    try {
      const signParams = getSignParams();
      
      const requestData = {
        loginType: 2,
        mobilePhone: mobilePhone,
        type: 1,
        driverPassword: password,
        appKey: 'invitation_link',
      };

      const response = await request.post('/api/driverUser/passwordLogin', requestData, signParams);

      Toast.hide();
      
      if (response && response.data && response.data.errorCode === 0) {
        // 登录成功
        const { data } = response.data;
        const { token, driverDetail } = data;
        
        Toast.success('登录成功', 1);
        
        // 存储token到localStorage（可选）
        if (token) {
          localStorage.setItem('userToken', token);
        }
         if (driverDetail) {
          localStorage.setItem('driverDetail', JSON.stringify(driverDetail));
        }
        
        // 跳转到入口
        setTimeout(() => {
          history.push('/home');
        }, 1000);
        
      } else {
        // 登录失败
        const errorMsg = response?.data?.errorMsg || '登录失败，请稍后重试';
        Toast.fail(errorMsg, 2);
      }
    } catch (error) {
      console.error('登录请求失败', error);
      Toast.hide();
      Toast.fail('网络错误，请检查网络连接', 2);
    } finally {
      setLoading(false);
    }
  };

  // 处理注册
  const handleRegister = async () => {
    // 验证手机号
    if (!mobilePhone) {
      Toast.fail('请输入手机号', 2);
      return;
    }
    
    // if (!validatePhone(mobilePhone)) {
    //   Toast.fail('请输入正确的手机号', 2);
    //   return;
    // }

    // 验证密码
    if (!password) {
      Toast.fail('请输入密码', 2);
      return;
    }

    if (!validatePassword(password)) {
      Toast.fail('密码至少6位', 2);
      return;
    }

    setLoading(true);
    Toast.loading('注册中...', 0, () => {}, true);

    try {
      const signParams = getSignParams();
      
      const requestData = {
        driverPassword: password,
        loginType: 2,
        mobilePhone: mobilePhone,
        appKey: 'weChat',
      };

      const response = await request.post('/api/driverUser/registerByPwd', requestData, signParams);

      Toast.hide();
      
      if (response && response.data && response.data.errorCode === 0) {
        // 注册成功
        const { data } = response.data;
        const { token, driverDetail } = data;
        
        Toast.success('注册成功', 1);
        
        // 存储token到localStorage
        if (token) {
          localStorage.setItem('userToken', token);
        }
        if (driverDetail) {
          localStorage.setItem('driverDetail', JSON.stringify(driverDetail));
        }
        
        // 跳转到入口
        setTimeout(() => {
          history.push('/home');
        }, 1000);
        
      } else {
        // 注册失败
        const errorMsg = response?.data?.errorMsg || '注册失败，请稍后重试';
        Toast.fail(errorMsg, 2);
      }
    } catch (error) {
      console.error('注册请求失败', error);
      Toast.hide();
      Toast.fail('网络错误，请检查网络连接', 2);
    } finally {
      setLoading(false);
    }
  };

  // 处理键盘回车事件
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      isRegisterMode ? handleRegister() : handleLogin();
    }
  };

  return (
    <div className="login-container">
      <div className="login-header">
        <div className="logo-wrapper">
          <img src={config.LOGO_IMG} alt="logo" className="logo" />
          <h1 className="app-title">{config.TITLE}</h1>
        </div>
      </div>

      <div className="login-form">
        <div className="form-title">
          <h2>{isRegisterMode ? '账号密码注册' : '账号密码登录'}</h2>
          <p>{isRegisterMode ? '请输入您的手机号和密码进行注册' : '请输入您的手机号和密码'}</p>
        </div>

        <div className="input-group">
          <div className="input-wrapper">
            <div className="input-icon">
              <i className="iconfont icon-phone"></i>
            </div>
            <input
              type="tel"
              placeholder="请输入手机号"
              value={mobilePhone}
              onChange={(e) => setMobilePhone(e.target.value.replace(/[^\d]/g, '').slice(0, 11))}
              onKeyPress={handleKeyPress}
              maxLength="11"
              className="form-input"
            />
          </div>
        </div>

        <div className="input-group">
          <div className="input-wrapper">
            <div className="input-icon">
              <i className="iconfont icon-lock"></i>
            </div>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="请输入密码"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={handleKeyPress}
              className="form-input"
            />
            <div 
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              <i className={`iconfont ${showPassword ? 'icon-eye-open' : 'icon-eye-close'}`}></i>
            </div>
          </div>
        </div>

        <button
          className={`login-btn ${loading ? 'loading' : ''}`}
          onClick={isRegisterMode ? handleRegister : handleLogin}
          disabled={loading}
        >
          {loading ? (isRegisterMode ? '注册中...' : '登录中...') : (isRegisterMode ? '注册' : '登录')}
        </button>

        <div className="mode-switch">
          <p>
            {isRegisterMode ? '已有账号？' : '还没有账号？'}
            <span 
              className="switch-link" 
              onClick={() => setIsRegisterMode(!isRegisterMode)}
            >
              {isRegisterMode ? '立即登录' : '立即注册'}
            </span>
          </p>
        </div>

        <div className="login-tips">
          <p>{isRegisterMode ? '注册即表示您同意相关服务协议和隐私政策' : '登录即表示您同意相关服务协议和隐私政策'}</p>
        </div>
      </div>

      <div className="login-footer">
        <p>如有问题，请联系客服：{config.TEL}</p>
      </div>
    </div>
  );
};

export default Login;